import {
  DELETE_HNW_ASSESSMENT_DETAIL,
  FETCH_CUSTOMER_PIF_CART,
  FETCH_HNW_ASSESSMENT,
  FETCH_HNW_ASSESSMENT_DETAIL,
  FETCH_HNW_ASSESSMENT_HISTORY_LOG,
  FETCH_HNW_ASSESSMENT_LIST,
  FETCH_TERMS_CONDITIONS,
  GET_HNW_PRODUCTS,
  GET_HNW_SCORE,
  GET_LAST_SAVED_ANSWERS,
  GET_SKIN_ASSESSMENT_RESULT,
  RESET_ASSESSMENT_SCORE,
  RESET_SKIN_ASSESSMENT_ANSWERS,
  SAVE_SKIN_ASSESSMENT_ANSWERS,
  UPDATE_HNW_ANSWER
} from '../actions/types';

export default function (state = {}, action) {
  console.log(action, 'payload');
  switch (action.type) {
    case FETCH_HNW_ASSESSMENT_LIST:
      return { ...state, assessmentList: action.payload };
    case FETCH_HNW_ASSESSMENT:
      return { ...state, assessmentQuestions: action.payload };
    case UPDATE_HNW_ANSWER:
      return {
        ...state,
        assessmentAnswerResult: action.payload,
        assessmentAnswerError: action.hasError,
      };
    case FETCH_HNW_ASSESSMENT_DETAIL:
      return { ...state, assessmentDetail: action.payload };
    case FETCH_HNW_ASSESSMENT_HISTORY_LOG:
      return { ...state, assessmentHistoryLog: action.payload };
    case DELETE_HNW_ASSESSMENT_DETAIL:
      return { ...state, assessmentDeleteResult: action.payload };
    case GET_HNW_SCORE:
      return { ...state, assessmentScore: action.payload };
    case FETCH_CUSTOMER_PIF_CART:
      return { ...state, customerCart: action.payload };
    case GET_HNW_PRODUCTS:
      return {
        ...state,
        assessmentProducts: {
          ...state.assessmentProducts,
          [action.payload.type]: action.payload.result,
        },
      };
    case RESET_ASSESSMENT_SCORE:
      return { ...state, assessmentScore: null };
    case FETCH_TERMS_CONDITIONS:
      return { ...state, assessmentTerms: action.payload };
    case SAVE_SKIN_ASSESSMENT_ANSWERS:
      const { question_id, question_label, answer_ids, previous_answer_ids } = action.payload;
      return {
        ...state,
        localAnswers:
        {
          ...(state.localAnswers || {}),
          [question_label]: {
            question_id,
            answer_ids,
            previous_answer_ids: previous_answer_ids || [],
          },
        },
      };
    case GET_SKIN_ASSESSMENT_RESULT:
      return {
        ...state,
        skinResult: action.payload
      }
    case GET_LAST_SAVED_ANSWERS:
      const { saved_question_id, saved_question_label, saved_answer_ids } = action.payload;
      return {
        ...state,
        lastSavedAnswers: {
          ...(state.lastSavedAnswers || {}),
          [saved_question_label]: {
            saved_question_id, saved_answer_ids
          }
        },
      };
    case RESET_SKIN_ASSESSMENT_ANSWERS:
      return {
        ...state,
        localAnswers: {},
        lastSavedAnswers: {}
      };
    default:
      return state;
  }
}
